export default __webpack_public_path__ + "assets/images/1663bfc0fde5c7184dd65b36ee6e4b32.png";